const loadOneTrustScripts = (): void => {
  const otAutoBlockScript = document.createElement('script');
  otAutoBlockScript.src = `https://cdn.cookielaw.org/consent/${
    import.meta.env.VITE_REACT_APP_DATA_DOMAIN_SCRIPT
  }/OtAutoBlock.js`;
  otAutoBlockScript.type = 'text/javascript';
  document.head.appendChild(otAutoBlockScript);

  const otSDKStubScript = document.createElement('script');
  otSDKStubScript.src =
    'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
  otSDKStubScript.type = 'text/javascript';
  otSDKStubScript.dataset.domainScript =
    import.meta.env.VITE_REACT_APP_DATA_DOMAIN_SCRIPT;
  otSDKStubScript.dataset.documentLanguage = 'true';
  document.head.appendChild(otSDKStubScript);
};

export { loadOneTrustScripts };
